'use client';
import { useRouter } from 'next/navigation';
import React from 'react';
import * as LucideIcons from 'lucide-react';

export default function NavButton({
  name,
  url,
  type = 'push',
  icon,
  iconName,
}: {
  name: string;
  url?: string;
  type?: 'push' | 'replace' | 'back';
  icon?: React.ReactNode;
  iconName?: keyof typeof LucideIcons;
}) {
  const router = useRouter();
  const handleClick = () => {
    if (type === 'back') router.back();
    else if (type === 'replace' && url) router.replace(url);
    else if (type === 'push' && url) router.push(url);
  };
  // Dynamically render Lucide icon if iconName is provided
  let LucideIconComponent: React.ReactNode = null;
  if (iconName && LucideIcons[iconName]) {
    const Icon = LucideIcons[iconName] as React.ComponentType<{ size?: number }>;
    LucideIconComponent = <Icon data-component-id="src/components/ui/Button.tsx:29:26" data-component-path="src/components/ui/Button.tsx" data-component-line="29" data-component-end-line="29" data-component-file="Button.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" size={18} />;
  }
  return (
    <button data-component-id="src/components/ui/Button.tsx:32:4" data-component-path="src/components/ui/Button.tsx" data-component-line="32" data-component-end-line="41" data-component-file="Button.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22mt-2%20px-2%20py-2%20rounded%20bg-%5B%235B8CFF%5D%20text-white%20font-semibold%20hover%3Abg-%5B%237C9DFF%5D%20transition%20flex%20items-center%20gap-2%22%2C%22type%22%3A%22button%22%7D"
      className="mt-2 px-2 py-2 rounded bg-[#5B8CFF] text-white font-semibold hover:bg-[#7C9DFF] transition flex items-center gap-2"
      type="button"
      onClick={handleClick}
    >
      {/* Icon: hidden on sm/md, visible on lg+ */}
      {icon && <span data-component-id="src/components/ui/Button.tsx:38:15" data-component-path="src/components/ui/Button.tsx" data-component-line="38" data-component-end-line="38" data-component-file="Button.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22hidden%20lg%3Ainline-flex%22%7D" className="hidden lg:inline-flex">{icon}</span>}
      {LucideIconComponent && <span data-component-id="src/components/ui/Button.tsx:39:30" data-component-path="src/components/ui/Button.tsx" data-component-line="39" data-component-end-line="39" data-component-file="Button.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22hidden%20lg%3Ainline-flex%22%7D" className="hidden lg:inline-flex">{LucideIconComponent}</span>}
      {name}
    </button>
  );
}
